export default [{
  name: 'logoutAuto',
  path: '/logout/auto',
  component: require('@/pages/logout/Auto.vue').default
}]
